import type { TChatMessageRole, TChatPlaybackMessage } from "./chat-playback";

export type TChatTurn = {
	role: TChatMessageRole;
	messages: TChatPlaybackMessage[];
};

export function groupChatTurns(messages: readonly TChatPlaybackMessage[]): TChatTurn[] {
	const turns: TChatTurn[] = [];

	for (const message of messages) {
		const lastTurn = turns[turns.length - 1];
		if (lastTurn && lastTurn.role === message.role) {
			lastTurn.messages.push(message);
			continue;
		}
		turns.push({ role: message.role, messages: [message] });
	}

	return turns;
}
